// @flow
import {
  InterventionRegistrationType,
  InterventionRegistrationTypeAbsent,
  InterventionRegistrationTypeCanceled,
  InterventionRegistrationTypeExcused,
  InterventionRegistrationTypePresent,
  InterventionRegistrationTypeScheduled,
} from '@root/src/Intervention/types';

export const INTERVENTION_REGISTRATION_TYPE_SCHEDULED: InterventionRegistrationTypeScheduled = 'scheduled';
export const INTERVENTION_REGISTRATION_TYPE_PRESENT: InterventionRegistrationTypePresent = 'present';
export const INTERVENTION_REGISTRATION_TYPE_ABSENT: InterventionRegistrationTypeAbsent = 'absent';
export const INTERVENTION_REGISTRATION_TYPE_EXCUSED: InterventionRegistrationTypeExcused = 'excused';
export const INTERVENTION_REGISTRATION_TYPE_CANCELED: InterventionRegistrationTypeCanceled = 'canceled';

// only visible on the frontend
export const INTERVENTION_REGISTRATION_STATUSES: InterventionRegistrationType[] = [
  INTERVENTION_REGISTRATION_TYPE_SCHEDULED,
  INTERVENTION_REGISTRATION_TYPE_PRESENT,
  INTERVENTION_REGISTRATION_TYPE_ABSENT,
  INTERVENTION_REGISTRATION_TYPE_EXCUSED,
];
